import type { ReactNode } from 'react';

/**
 * Inline rounded chip used to render a severity tier (alert severity, SWA
 * severity, etc.) with its count inside dashboard cards. The render is
 * intentionally smaller than the Shadcn `Badge` (no border, smaller
 * radius, no fixed height).
 *
 * Color decisions stay at the call site: pass the severity-to-class
 * lookup result via `className`. Alert and SWA palettes intentionally
 * differ (and SWA palettes differ between Executive and Supervisor
 * widgets), so the shared primitive is render-only.
 *
 * Consumed by ExecutiveDashboard (SWA chip), SafetyManagerDashboard
 * (alert chip), and SupervisorDashboard (alert + SWA chips).
 */
export interface SeverityChipProps {
  className?: string;
  children: ReactNode;
}

export function SeverityChip({ className = '', children }: SeverityChipProps) {
  return (
    <span className={`rounded px-1.5 py-0.5 text-xs ${className}`}>
      {children}
    </span>
  );
}
